<template>
    <nav class="flex justify-start">
        <button
            class="
                nio-button nio-button-blue
                flex justify-center items-center px-6 py-6 border-r border-gray-200
            "
            :class="[ activeTab == tab.value ? 'active text-white' : 'bg-white' ]"
            :key="tab.value"
            @click="$emit('update:activeTab', tab.value)"
            v-for="tab in tabs"
        >
            <nio-icon
                class="mr-2 text-lg"
                :name="tab.icon"
                v-if="tab.icon"
            />
            <span>
                {{ tab.text }}
            </span>
        </button>
    </nav>
</template>

<script>
    export default {
        props: {
            tabs: {
                type: Array,
                required: true,
            },
            activeTab: {
                type: String,
                required: true,
            },
        },
    };
</script>
